<!--
 * @Descripttion:静态卡片属性配置
 * @Author: zenghua.wang
 * @Date: 2021-09-26 17:35:55
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:03:46
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <card-field :data="data" />
        <config-filter :data="data" />
      </template>
    </api-interface>

    <!-- 卡片设置 -->
    <el-collapse-item title="卡片设置">
      <card-common :data="data" />
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'

import cardCommon from './common.vue'
import cardField from './field.vue'

export default {
  name: 'config-card',
  components: {
    configBase,
    configAuth,
    cardCommon,
    cardField,
    configFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component
    }
  }
}
</script>
